<app-gallery-settings-customize-header
  title="Asset Status"
  location="asset-status-setting-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group title="Customize States" location="asset-status-setting-customize">
  <app-access-item
    [icon]="'/assets/icons/' + icons.rejected + '.svg'"
    [iconColor]="rejected() ? iconColors.rejected : 'grey'"
  >
    <app-access-item-header>
      <span>Rejected</span>
    </app-access-item-header>
    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="asset-status-rejected"
          [(ngModel)]="rejected"
          (ngModelChange)="updateAssetStatuses()"
        />
        <label for="asset-status-rejected" data-test-id="asset-status-rejected"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item
    [icon]="'/assets/icons/' + icons.needs_review + '.svg'"
    [iconColor]="needs_review() ? iconColors.needs_review : 'grey'"
  >
    <app-access-item-header>
      <span>Needs Review</span>
    </app-access-item-header>
    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="asset-status-needs-review"
          [(ngModel)]="needs_review"
          (ngModelChange)="updateAssetStatuses()"
        />
        <label for="asset-status-needs-review" data-test-id="asset-status-needs-review"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item
    [icon]="'/assets/icons/' + icons.in_progress + '.svg'"
    [iconColor]="in_progress() ? iconColors.in_progress : 'grey'"
  >
    <app-access-item-header>
      <span>In Progress</span>
    </app-access-item-header>
    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="asset-status-in-progress"
          [(ngModel)]="in_progress"
          (ngModelChange)="updateAssetStatuses()"
        />
        <label for="asset-status-in-progress" data-test-id="asset-status-in-progress"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item
    [icon]="'/assets/icons/' + icons.approved + '.svg'"
    [iconColor]="approved() ? iconColors.approved : 'grey'"
  >
    <app-access-item-header>
      <span>Approved</span>
    </app-access-item-header>
    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="asset-status-approved"
          [(ngModel)]="approved"
          (ngModelChange)="updateAssetStatuses()"
          [disabled]="true"
        />
        <label for="asset-status-approved" data-test-id="asset-status-approved"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>
</app-gallery-settings-group>

<app-gallery-settings-group
  title="Approval Limit"
  location="asset-status-setting-customize"
  scope="gallery:approval-limit"
>
  <p>Set the maximum number of approvals.</p>

  <app-access-item
    [icon]="'/assets/icons/mixed-status.svg'"
    [iconColor]="limitActive() ? 'green' : 'grey'"
    data-test-id="approval-limit"
  >
    <app-access-item-body>
      <div class="field-content">
        <app-input-field [noLabel]="true" [smallNoLabel]="true" class="headless">
          <input
            type="number"
            [(ngModel)]="limitValue"
            (ngModelChange)="updateApprovalLimitDebounced()"
            [placeholder]="'Limit (e.g., 24)'"
            [disabled]="!limitActive() || !('gallery:approval-limit' | billingScope)"
            data-test-id="approval-limit-input"
          />
        </app-input-field>
        <app-switch [small]="true">
          <input
            type="checkbox"
            id="approval-limit"
            [(ngModel)]="limitActive"
            (ngModelChange)="updateApprovalLimit()"
            [disabled]="!('gallery:approval-limit' | billingScope)"
          />
          <label for="approval-limit"></label>
        </app-switch>
      </div>
    </app-access-item-body>
  </app-access-item>

  @if (limitActive()) {
    <app-radio
      class="soft-limit"
      [small]="true"
      [checked]="softLimit()"
      color="grey-60"
      (click)="softLimit.set(!softLimit()); updateApprovalLimit()"
    >
      Allow customers to exceed this limit
    </app-radio>
  }
</app-gallery-settings-group>
